module.exports = __webpack_public_path__ + "static/media/pregnancy-header-image.af162341.jpg";